/* eslint-disable no-shadow */
/* eslint-disable max-nested-callbacks */
/* eslint-disable max-depth */
import React, { useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Collapse } from 'reactstrap';
import navdata from '../LayoutMenuData';
import { withTranslation } from 'react-i18next';
import withRouter from '../../Components/Common/withRouter';
import { useSelector } from 'react-redux';
import { createSelector } from 'reselect';
// import { getLoginUserMenuRoutes } from 'Components/Common/Util';
import SvgIcon from 'Components/Common/SvgIcon';
import { AuthUser, getLoginUserMenuRoutes } from 'Components/Common/Util';

const selectRoleState = (state: any) => state.SelectedRole;
const selectRoleProperties: any = createSelector(selectRoleState, (roleValues) => ({
    role: roleValues.role,
    error: roleValues.error
}));

const VerticalLayout = (props: any) => {
    const navData = navdata().props.children;
    let menuSplitContainer = 25;
    const menuItems: any[] = [];
    const splitMenuItems: Array<any> = [];
    const menuItemsList: any = [];

    const { role }: any = useSelector(selectRoleProperties);

    // privileges must be from the user details or selected role details
    // if the user has the multiple roles then based on the selected role filter the sidebar items
    // if the user has only single role then based on the response privileges need to show the
    const loggedInDetails = AuthUser();
    const hasMultipleRoles = loggedInDetails?.userProfile?.roles?.length > 1;

    const privileges = hasMultipleRoles ? role?.privileges : loggedInDetails?.userProfile?.roles?.[0]?.privileges;


    navData?.forEach(
        (value: { subItems: any[]; create: string; view: string; edit: string; delete: string; link: (url: string) => string }) => {
            if (value.subItems) {
                const subMenu: any[] = [];
                value?.subItems?.forEach((subItem: { editor: any; create: any; view: any; edit: any; delete: any; link: any }) => {
                    const checkValid = true;
                    if (checkValid) {
                        if (subItem.create || subItem.view || subItem.edit || subItem.delete) {
                            privileges?.forEach((privilege: any) => {
                                if (
                                    privilege?.toUpperCase() === subItem.create?.toUpperCase() ||
                                    privilege?.toUpperCase() === subItem.view?.toUpperCase() ||
                                    privilege?.toUpperCase() === subItem.edit?.toUpperCase() ||
                                    privilege?.toUpperCase() === subItem.delete?.toUpperCase()
                                ) {
                                    const item = subMenu.findIndex((menu) => menu.link === subItem.link);
                                    if (item === -1) subMenu.push(subItem);
                                }
                            });
                        } else subMenu.push(subItem);
                    }
                });

                if (subMenu.length > 0) {
                    value.subItems = subMenu;
                    menuItemsList.push(value);
                }
            } else {
                if (value.create || value.view || value.edit || value.delete) {
                    const checkValid = true;
                    if (checkValid)
                        privileges?.forEach((privilege: any) => {
                            if (
                                privilege?.toUpperCase() === value.create?.toUpperCase() ||
                                privilege?.toUpperCase() === value.view?.toUpperCase() ||
                                privilege?.toUpperCase() === value.edit?.toUpperCase() ||
                                privilege?.toUpperCase() === value.delete?.toUpperCase()
                            ) {
                                const item = menuItemsList.findIndex((menu: string) => menu.link === value.link);
                                if (item === -1) menuItemsList.push(value);
                            }
                        });
                } else {
                    const checkValid = false;
                    if (checkValid) menuItemsList.push(value);
                }
            }
        }
    );

    menuItemsList.forEach(function (value: any, key: number) {
        if (value['isHeader']) {
            menuSplitContainer++;
        }
        if (key >= menuSplitContainer) {
            const val = value;
            val.childItems = value.subItems;
            val.isChildItem = value.subItems ? true : false;
            delete val.subItems;
            splitMenuItems.push(val);
        } else {
            menuItems.push(value);
        }
    });

    /*
     *layout settings
     */

    const selectLayoutState = (state: any) => state.Layout;
    const selectLayoutProperties = createSelector(selectLayoutState, (layout) => ({
        leftsidbarSizeType: layout.leftsidbarSizeType,
        sidebarVisibilitytype: layout.sidebarVisibilitytype,
        layoutType: layout.layoutType
    }));
    // Inside your component
    const { leftsidbarSizeType, sidebarVisibilitytype, layoutType } = useSelector(selectLayoutProperties);

    // vertical and semibox resize events
    const resizeSidebarMenu = useCallback(() => {
        const windowSize = document.documentElement.clientWidth;
        const humberIcon = document.querySelector('.hamburger-icon') as HTMLElement;
        const hamburgerIcon = document.querySelector('.hamburger-icon');
        if (windowSize >= 1025) {
            if (document.documentElement.getAttribute('data-layout') === 'vertical') {
                document.documentElement.setAttribute('data-sidebar-size', leftsidbarSizeType);
            }
            if (document.documentElement.getAttribute('data-layout') === 'semibox') {
                document.documentElement.setAttribute('data-sidebar-size', leftsidbarSizeType);
            }
            if (
                (sidebarVisibilitytype === 'show' || layoutType === 'vertical' || layoutType === 'twocolumn') &&
                document.querySelector('.hamburger-icon')
            ) {
                if (hamburgerIcon !== null) {
                    hamburgerIcon.classList.remove('open');
                }
            } else {
                // var hamburgerIcon = document.querySelector(".hamburger-icon");
                if (hamburgerIcon !== null) {
                    hamburgerIcon.classList.add('open');
                }
            }
        } else if (windowSize < 1025 && windowSize > 767) {
            document.body.classList.remove('twocolumn-panel');
            if (document.documentElement.getAttribute('data-layout') === 'vertical') {
                document.documentElement.setAttribute('data-sidebar-size', 'sm');
            }
            if (document.documentElement.getAttribute('data-layout') === 'semibox') {
                document.documentElement.setAttribute('data-sidebar-size', 'sm');
            }
            if (humberIcon) {
                humberIcon.classList.add('open');
            }
        } else if (windowSize <= 767) {
            document.body.classList.remove('vertical-sidebar-enable');
            if (document.documentElement.getAttribute('data-layout') !== 'horizontal') {
                document.documentElement.setAttribute('data-sidebar-size', 'lg');
            }
            if (humberIcon) {
                humberIcon.classList.add('open');
            }
        }
    }, [leftsidbarSizeType, sidebarVisibilitytype, layoutType]);

    useEffect(() => {
        window.addEventListener('resize', resizeSidebarMenu, true);
    }, [resizeSidebarMenu]);

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        const initMenu = () => {
            const pathName = process.env.PUBLIC_URL + window.location.href;
            const ul = document.getElementById('navbar-nav');
            const items: any = ul?.getElementsByTagName('a');
            const itemsArray = [...items]; // converts NodeList to Array
            removeActivation(itemsArray);
            const matchingMenuItem = itemsArray.find((x) => {
                const routeArr = x.href?.split('/').filter((v: any) => v !== '');
                return pathName.includes(routeArr[3]);
            });
            if (matchingMenuItem) {
                activateParentDropdown(matchingMenuItem);
            }
        };
        if (props.layoutType === 'vertical') {
            initMenu();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [window.location.href, props.layoutType]);

    function activateParentDropdown(item: any) {
        item.classList.add('active');
        const parentCollapseDiv = item.closest('.collapse.menu-dropdown');

        if (parentCollapseDiv) {
            // to set aria expand true remaining
            parentCollapseDiv.classList.add('show');
            parentCollapseDiv.parentElement.children[0].classList.add('active');
            parentCollapseDiv.parentElement.children[0].setAttribute('aria-expanded', 'true');
            if (parentCollapseDiv.parentElement.closest('.collapse.menu-dropdown')) {
                parentCollapseDiv.parentElement.closest('.collapse').classList.add('show');
                if (parentCollapseDiv.parentElement.closest('.collapse').previousElementSibling)
                    parentCollapseDiv.parentElement.closest('.collapse').previousElementSibling.classList.add('active');
                if (parentCollapseDiv.parentElement.closest('.collapse').previousElementSibling.closest('.collapse')) {
                    parentCollapseDiv.parentElement.closest('.collapse').previousElementSibling.closest('.collapse').classList.add('show');
                    parentCollapseDiv.parentElement
                        .closest('.collapse')
                        .previousElementSibling.closest('.collapse')
                        .previousElementSibling.classList.add('active');
                }
            }
            return false;
        }
        return false;
    }

    const removeActivation = (items: any) => {
        const actiItems = items.filter((x: any) => x.classList.contains('active'));

        actiItems.forEach((item: any) => {
            if (item.classList.contains('menu-link')) {
                if (!item.classList.contains('active')) {
                    item.setAttribute('aria-expanded', false);
                }
                if (item.nextElementSibling) {
                    item.nextElementSibling.classList.remove('show');
                }
            }
            if (item.classList.contains('nav-link')) {
                if (item.nextElementSibling) {
                    item.nextElementSibling.classList.remove('show');
                }
                item.setAttribute('aria-expanded', false);
            }
            item.classList.remove('active');
        });
    };

    const filteredItems = getLoginUserMenuRoutes(privileges, navData);
    return (
        <React.Fragment>
            {/* menu Items */}
            {(filteredItems || []).map((item: any, key: number) => {
                return (
                    <React.Fragment key={key}>
                        {/* Main Header */}
                        {item['isHeader'] ? (
                            <li className="menu-title">
                                <span data-key="t-menu">{props.t(item.label)} </span>
                            </li>
                        ) : item.subItems ? (
                            <li className="nav-item">
                                <Link
                                    onClick={item.click}
                                    className="nav-link menu-link"
                                    to={item.link ? item.link : '/#'}
                                    data-bs-toggle="collapse"
                                >
                                    {item.image && <SvgIcon name={item.id} className="ms-1" size={32} />}
                                    {!item.image && item.icon && <i className={item.icon}></i>}
                                    <span data-key="t-apps">{props.t(item.label)}</span>
                                    {item.badgeName ? (
                                        <span className={'badge badge-pill bg-' + item.badgeColor} data-key="t-new">
                                            {item.badgeName}
                                        </span>
                                    ) : null}
                                </Link>
                                <Collapse className="menu-dropdown" isOpen={item.stateVariables} id="sidebarApps">
                                    <ul className="nav nav-sm flex-column test">
                                        {/* subItms  */}
                                        {item.subItems &&
                                            (item.subItems || []).map((subItem: any, key: number) => (
                                                <React.Fragment key={key}>
                                                    {!subItem.isChildItem ? (
                                                        <li className="nav-item">
                                                            <Link to={subItem.link ? subItem.link : '/#'} className="nav-link">
                                                                {props.t(subItem.label)}
                                                                {subItem.badgeName ? (
                                                                    <span
                                                                        className={'badge badge-pill bg-' + subItem.badgeColor}
                                                                        data-key="t-new"
                                                                    >
                                                                        {subItem.badgeName}
                                                                    </span>
                                                                ) : null}
                                                            </Link>
                                                        </li>
                                                    ) : (
                                                        <li className="nav-item">
                                                            <Link
                                                                onClick={subItem.click}
                                                                className="nav-link"
                                                                to="/#"
                                                                data-bs-toggle="collapse"
                                                            >
                                                                {props.t(subItem.label)}
                                                                {subItem.badgeName ? (
                                                                    <span
                                                                        className={'badge badge-pill bg-' + subItem.badgeColor}
                                                                        data-key="t-new"
                                                                    >
                                                                        {subItem.badgeName}
                                                                    </span>
                                                                ) : null}
                                                            </Link>
                                                            <Collapse
                                                                className="menu-dropdown"
                                                                isOpen={subItem.stateVariables}
                                                                id="sidebarEcommerce"
                                                            >
                                                                <ul className="nav nav-sm flex-column">
                                                                    {/* child subItms  */}
                                                                    {subItem.childItems &&
                                                                        (subItem.childItems || []).map((childItem: any, key: number) => (
                                                                            <React.Fragment key={key}>
                                                                                {!childItem.childItems ? (
                                                                                    <li className="nav-item">
                                                                                        <Link
                                                                                            to={childItem.link ? childItem.link : '/#'}
                                                                                            className="nav-link"
                                                                                        >
                                                                                            {props.t(childItem.label)}
                                                                                        </Link>
                                                                                    </li>
                                                                                ) : (
                                                                                    <li className="nav-item">
                                                                                        <Link
                                                                                            to="/#"
                                                                                            className="nav-link"
                                                                                            onClick={childItem.click}
                                                                                            data-bs-toggle="collapse"
                                                                                        >
                                                                                            {props.t(childItem.label)}
                                                                                        </Link>
                                                                                        <Collapse
                                                                                            className="menu-dropdown"
                                                                                            isOpen={childItem.stateVariables}
                                                                                            id="sidebaremailTemplates"
                                                                                        >
                                                                                            <ul className="nav nav-sm flex-column">
                                                                                                {childItem.childItems.map(
                                                                                                    (subChildItem: any, key: number) => (
                                                                                                        <li className="nav-item" key={key}>
                                                                                                            <Link
                                                                                                                to={subChildItem.link}
                                                                                                                className="nav-link"
                                                                                                                data-key="t-basic-action"
                                                                                                            >
                                                                                                                {props.t(
                                                                                                                    subChildItem.label
                                                                                                                )}{' '}
                                                                                                            </Link>
                                                                                                        </li>
                                                                                                    )
                                                                                                )}
                                                                                            </ul>
                                                                                        </Collapse>
                                                                                    </li>
                                                                                )}
                                                                            </React.Fragment>
                                                                        ))}
                                                                </ul>
                                                            </Collapse>
                                                        </li>
                                                    )}
                                                </React.Fragment>
                                            ))}
                                    </ul>
                                </Collapse>
                            </li>
                        ) : (
                            <li className="nav-item">
                                <Link className="nav-link menu-link fw-semibold" to={item.link ? item.link : '/#'} onClick={item.click}>
                                    {item.image && <SvgIcon name={item.id} className="ms-1" size={32} />}
                                    {!item.image && item.icon && <i className={item.icon}></i>}
                                    <span>{props.t(item.label)}</span>
                                    {item.badgeName ? (
                                        <span className={'badge badge-pill bg-' + item.badgeColor} data-key="t-new">
                                            {item.badgeName}
                                        </span>
                                    ) : null}
                                </Link>
                            </li>
                        )}
                    </React.Fragment>
                );
            })}
        </React.Fragment>
    );
};

VerticalLayout.propTypes = {
    location: PropTypes.object,
    t: PropTypes.any
};

export default withRouter(withTranslation()(VerticalLayout));
